import { render, staticRenderFns } from "./DefaultNavbar.vue?vue&type=template&id=57388a60&scoped=true&"
import script from "./DefaultNavbar.vue?vue&type=script&lang=js&"
export * from "./DefaultNavbar.vue?vue&type=script&lang=js&"
import style0 from "./DefaultNavbar.vue?vue&type=style&index=0&id=57388a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57388a60",
  null
  
)

export default component.exports